export default __webpack_public_path__ + "static/media/bgFigure.f59de290.svg";